import React from "react";
import { DashboardHomeEnAPI, abortFetch } from "../../action/actionCreatorsRequests";
import {
    MSGOK, recortarCadena, obtenerUsuario, obtenerToken, traducirPagina, convertirCodigoAMeses, dynamicSortAsc, dynamicSortDesc

} from "../../librerias/funciones"

import { Drawer, Select } from 'antd';

import {
    CloseOutlined
} from '@ant-design/icons';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";


export const FichaVentaOnline = (props) => {
    const ref = React.useRef(null)
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);

    const [initComponent, setInitComponent] = React.useState({
        TXT_FILTRO: "",
        VENTAS_ONLINE: [],
        VENTAS_ONLINE_ANYO: { MES: 0, ANYO: 2022 }
    })

    const [registroKeyGrafico, setRegistroKeyGrafico] = React.useState([

        {
            "NOMBRE": 2021,
            "ACTIVO": true,
            "COLOR": "var(--azul-claro-serca)",
            "ANYO": 2021,
        },
        {
            "NOMBRE": 2022,
            "ACTIVO": true,
            "COLOR": "#000",
            "ANYO": 2022,
        }
    ]);



    const obtenerMesPeriodo = (REGISTRO) => {
        return REGISTRO === 0 ? { INICIO: 1, FIN: 12 } : { INICIO: REGISTRO, FIN: REGISTRO }
    }


    const obtenerEstadisticaEjercicioGrafico = (registros, LISTA_ANYOS) => {
        let ANYOS = LISTA_ANYOS;

        let grafico = [];
        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO == item.MES)
            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.MES_DESCRIPCION,
                    "MES_NO": item.MES,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES === registro.MES_NO);
            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO == registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;
                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = parseInt(lista.IMPORTE.replace(",", "."));

            })
        })
        console.log("res", grafico)
        return grafico;
    }





    const bucarRegistros = async (MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS) => {
        let RESULTADOS = null
        let registros = await DashboardHomeEnAPI(MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS)
        if (registros !== undefined && registros !== null && registros.REGISTROS !== undefined && registros.REGISTROS !== null) {
            RESULTADOS = registros.REGISTROS;
        }

        return RESULTADOS;
    }



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })

    React.useEffect(() => {
        const {ID_SOCIO,VENTAS_ANYO} = props.DATOS

        registroKeyGrafico[0].NOMBRE = VENTAS_ANYO.ANYO - 1
        registroKeyGrafico[0].ANYO = VENTAS_ANYO.ANYO - 1

        registroKeyGrafico[1].NOMBRE = VENTAS_ANYO.ANYO 
        registroKeyGrafico[1].ANYO = VENTAS_ANYO.ANYO 


        setRegistroKeyGrafico([...registroKeyGrafico])


        //VENTAS ONLINE 4
        bucarRegistros(1, 12, VENTAS_ANYO.ANYO, 5, ID_SOCIO, null).then((registros) => {
            initComponent.VENTAS_ONLINE = registros
            setInitComponent({ ...initComponent })

        })

    }, [])


    const {ID_SOCIO,VENTAS_ANYO} = props.DATOS

    

    return <div>
        <Drawer
            width={1200}
            onClose={() => {
                props.CERRAR_FICHA(false)
            }}
            visible={props.ABRIR_FICHA}
            closable={false}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>


            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {
                        props.CERRAR_FICHA(false)


                    }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>
            </div>

            <div className="menu_mantenimiento" ref={ref}>

                <div className='mantenimiento_item1'>
                    <div className="titulo_venta_online">AÑO ACTUAL:<span>{VENTAS_ANYO.ANYO}</span></div>
                </div>

                <div className='mantenimiento_item2' style={{ gap: '10px' }}>

                </div>
            </div>



            <div className='container_tarifas' style={{ height: `calc(100vh - ${(50 + alturaSubmenu)}px )`,display:'flex',alignItems:'center' }}>

                {initComponent.VENTAS_ONLINE === null ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                    :

                    initComponent.VENTAS_ONLINE.length > 0 ?

                        <LineChart
                            width={1100}
                            height={600}
                            data={obtenerEstadisticaEjercicioGrafico(initComponent.VENTAS_ONLINE, [initComponent.VENTAS_ONLINE_ANYO.ANYO - 1, initComponent.VENTAS_ONLINE_ANYO.ANYO])}
                            margin={{
                                top: 0,
                                right: 10,
                                left: 20,
                                bottom: 2
                            }}
                        >
                            <CartesianGrid strokeDasharray="8 8" />
                            <XAxis dataKey="MES" />
                            <YAxis />
                            <Tooltip />
                             <Legend height={2}  />


                            {registroKeyGrafico.map((registro) =>
                                registroKeyGrafico.filter((item) => item.NOMBRE === registro.NOMBRE && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey={registro.NOMBRE} stroke={registro.COLOR} /> : null
                            )}

                        </LineChart>

                        :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>


                }

            </div>
        </Drawer>


    </div>;
};